var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5c.6 1 .9 2.1.9 3.3 0 3.4-2.9 7.7-5.3 10.7H4.4L2.2 3.9l3.7-.4 1.2 9.4c1.1-1.8 2.5-4.6 2.5-6.6 0-1.1-.2-1.8-.5-2.4l4.4-.4z",
    fill: "#3D95CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmoMark);
export default __webpack_public_path__ + "static/media/venmo-mark.6ac9f2279e8a612840aac605a13c50f3.svg";
export { ForwardRef as ReactComponent };